import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Text, FlexProps } from 'rebass'
import { useNewTranslation } from 'hooks'
import _ from 'lodash'

import Container from './layout/Container'
import { theme } from '../theme'

interface EmptyStateProps extends FlexProps {
    key?: string
    width?: string
    title?: string
    body?: string
}

const Loading: React.FC<EmptyStateProps> = ({ width, title, body, ...props }) => {
    const [t] = useNewTranslation()

    let titleText = title

    if (_.isEmpty(title)) {
        titleText = t('loadingState.loadingGenericPageSubtitle')
    }

    return (
        <Container mx="auto" width={width} sx={{ textAlign: 'center' }} {...props}>
            <Text color={theme.colors.boulder} mt={theme.spacing.s}>
                <FontAwesomeIcon icon={faSpinner} size="4x" spin />
            </Text>
            {titleText && (
                <Text color={theme.colors.boulder} fontWeight="bold" fontSize={3} my={theme.spacing.xs}>
                    {titleText}
                </Text>
            )}
            {body && (
                <Text color={theme.colors.boulder} fontSize={2} mt={theme.spacing.xs}>
                    {body}
                </Text>
            )}
        </Container>
    )
}

export default Loading
